import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Task } from '../models/Task';
import { environment } from '../../../../environments/environment';
import { HandleError, HttpErrorHandler } from '../../../shared/service/error.service';
import { Page } from 'src/app/shared/model/page';
import { TaskFilterForm } from '../../shared/models/TaskFilterForm';
import { NotificationFilterForm } from '../../anre/notifications-anre/models/NotificationFilterForm';

@Injectable({
  providedIn: 'root'
})
export class FinalClientNotificationsService {

  private readonly errorHandler: HandleError;

  constructor(private http: HttpClient, private httpErrorHandler: HttpErrorHandler) {
    this.errorHandler = httpErrorHandler.createHandleError('FinalClientNotificationsService');
  }

  getTasks(taskFilterForm: TaskFilterForm): Observable<Page<Task>> {
    return this.http.post<Page<Task>>(environment.baseUrl + '/notificari/lista-notificari', taskFilterForm)
      .pipe();
  }

  getNotifications(notificationFilterForm: NotificationFilterForm): Observable<Page<any>> {
    return this.http.post<Page<any>>(environment.loggedInUrl + '/notificari', notificationFilterForm);
  }

  markNotificationViewed(notificationId: number): Observable<any> {
    return this.http.put<any>(environment.baseUrl + `/message/${notificationId}`, null);
  }

}
